import { render, staticRenderFns } from "./Blockly.vue?vue&type=template&id=2c712f18&scoped=true&"
import script from "./Blockly.vue?vue&type=script&lang=js&"
export * from "./Blockly.vue?vue&type=script&lang=js&"
import style0 from "./Blockly.vue?vue&type=style&index=0&id=2c712f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c712f18",
  null
  
)

export default component.exports